// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ss-switcher {\n  display: flex;\n  align-items: center;\n}", "",{"version":3,"sources":["webpack://./resources/js/base/components/header-controls/SSUrlSwitcher.vue"],"names":[],"mappings":"AACA;EACI,aAAA;EACA,mBAAA;AAAJ","sourcesContent":["\n.ss-switcher {\n    display: flex;\n    align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
